<template>
  <div>
    <RevStickyBar class="md:hidden" :visible="true">
      <div class="flex flex-row items-end">
        <div class="mr-12 flex grow basis-0 flex-col">
          <span class="caption-bold">
            {{ i18n(translations.stickyButtonTotal) }}
          </span>
          <div class="flex flex-wrap">
            <span class="heading-2 mr-4"> {{ i18n.price(price) }}</span>
            <span
              v-if="marketPlace.features.vatIncluded"
              class="text-static-default-low caption mb-[0.175rem] mr-4 self-end"
            >
              {{ i18n(translations.tvaIncluded) }}</span
            >
            <span
              v-if="withMobilePlan || withSwap"
              class="caption-bold mb-[0.175rem] self-end"
            >
              {{ i18n(translations.stickyPriceDueToday) }}
            </span>
          </div>
          <span
            v-if="withSwap && priceWithSwap"
            class="text-static-default-low caption truncate"
          >
            {{
              i18n(translations.priceAfterTradeIn, {
                price: i18n.price(priceWithSwap),
              })
            }}
          </span>
        </div>

        <slot name="button" />
      </div>
    </RevStickyBar>
  </div>
</template>

<script setup lang="ts">
import type { Price } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { RevStickyBar } from '@ds/components/StickyBar'

import translations from './StickyBar.translations'

withDefaults(
  defineProps<{
    price: Price
    priceWithSwap?: Price
    withSwap?: boolean
    withMobilePlan?: boolean
  }>(),
  {
    priceWithSwap: undefined,
    withSwap: false,
    withMobilePlan: false,
  },
)

const marketPlace = useMarketplace()
const i18n = useI18n()
</script>
